import React, { useEffect, useState } from 'react';
import Cabecera from './components/Cabecera';
import InputRange from './components/InputRange';
import Ruleta from './components/Ruleta';
import Panel from './components/Panel';
import FrasePanel from './components/FrasePanel';
import Animation from './components/Animation';
import ResolverPanel from './components/ResolverPanel';
import InputLetter from './components/InputLetter';
import LetrasMencionadas from './components/LetrasMencionadas';
import Messages from './components/Messages';
import Button from './components/Button';
import Home from './components/Home';
import mapearGajos from './components/MapearGajos';
import Instrucciones from './components/Instrucciones';
import './Game.css';

let grados = 0;
let mensajeEnEspera = '';
let mensajeAbierto = true;
let juegoComenzado = false;
const frasePanel = FrasePanel();
console.log(frasePanel);

const Game = () => {
    useEffect(() => {
        const container = document.getElementById('game__container');
        const containerHeight = container.clientHeight;
        container.style.height = `${containerHeight}px`;
    });
    console.log('Dentro de Game');
    const [faltas, setFaltas] = useState(0);
    const [letrasMencionadas, setLetrasMencionadas] = useState([]);
    const [ruletaSize, setRuletaSize] = useState('small');
    const [panelSize, setPanelSize] = useState('big');
    const [inputRangeVisibility, setInputRangeVisibility] = useState('hidden');
    const [buttonsWrapperVisibility, setButtonsWrapperVisibility] = useState('');
    const [letrasMencionadasVisibility, setLetrasMencionadasvisibility] = useState('');
    const [buttonVocalState, setButtonVocalState] = useState('disabled');
    const [buttonResolverState, setButtonResolverState] = useState('');
    const [buttonGirarState, setButtonGirarState] = useState('');
    const [nextPanelVisibility, setNextPanelVisibility] = useState(false);
    const [inputLetterVisibility, setInputLetterVisibility] = useState('hidden');
    const [messageVisibility, setMessageVisibility] = useState('');
    const [currentPoints, setCurrentPoints] = useState(0);
    const [totalPoints, setTotalPoints] = useState(0);
    const [inputLetterType, setInputLetterType] = useState('consonante');
    const [resolverPanelVisibility, setResolverPanelVisibility] = useState(false);
    const [numeroAciertos, setNumeroAciertos] = useState(0);
    const [animationVisibility, setAnimationVisibility] = useState(false);
    const [manoVisibility, setManoVisibility] = useState(false);
    const [homeVisibility, setHomeVisibility] = useState(false);
    const [instructionsVisibility, setInstructionsVisibility] = useState(false);
    const [message, setMessage] = useState(<p><b>¡QUE EMPIECE EL JUEGO!</b><br /><br />En la parte
                                            superior de la pantalla puedes ver tu puntuación en todo momento
                                            y por cuánto estás jugando en cada tirada. <br /><br />En la parte
                                            inferior verás aparecer las letras que ya hayas mencionado.
                                            <br /><br />Para comenzar con tu primera tirada, haz click o
                                            presiona en la ruleta, ajusta la fuerza de tiro, y dale a Girar.
                                            <br />¡buena suerte!
                                           </p>);

    // Este condicional, aparte de comprobar el total de puntos para activar o desactivar
    // el botón para comprar vocal, también comprueba si el botón está ya activado o
    // desactivado porque sólo comprobando los puntos entraría en bucle de renderización.
    if (totalPoints >= 50 && buttonVocalState === 'disabled') {
        // Comprueba que no sea el final del juego, en ese caso no activa el botón de nuevo
        if (juegoComenzado !== 'end') {
            setButtonVocalState('');
        }
    } else if (totalPoints < 50 && buttonVocalState === '') {
        setButtonVocalState('disabled');
    }

    if (faltas > 2) {
        setFaltas(0);
        setTotalPoints(totalPoints / 2);
        console.log(`Mensaje de faltas: Mensaje en espera ${mensajeEnEspera}`);
        mostrarMessage('Has cometido tres faltas, tu puntuación se ha reducido a la mitad');
    }

    /* ------ FUNCIONES PARA MOSTRAR Y OCULTAR ELEMENTOS ------ */
    /* -------------------------------------------------------- */
    function mostrarRuleta() {
        if (ruletaSize === 'small') {
            setPanelSize('small');
            setRuletaSize('big');
            setInputRangeVisibility('');
            setButtonsWrapperVisibility('hidden');
            setLetrasMencionadasvisibility('hidden');
            setAnimationVisibility(false);
        }
        if (manoVisibility === true) {
            setManoVisibility(false);
        }
        if (nextPanelVisibility === true) {
            setNextPanelVisibility(false);
        }
    }

    function mostrarPanel() {
        if (panelSize === 'small') {
            setPanelSize('big');
            setRuletaSize('small');
            setInputRangeVisibility('hidden');
            setButtonsWrapperVisibility('');
            setLetrasMencionadasvisibility('');
        }
        if (juegoComenzado === 'end') {
            setNextPanelVisibility(true);
        }
    }

    function mostrarInputLetter() {
        setInputLetterVisibility('');
    }

    function ocultarInputLetter() {
        setInputLetterVisibility('hidden');
        setInputLetterType('consonante');
    }

    function mostrarMessage(textoMensaje) {
        // Comprueba que no haya ningún mensaje ya abierto para que un nuevo mensaje
        // no solape al que hubiera, en el caso de que lo hubiera, se guarda el
        // texto en una variable para mostrarlo en la función ocultarMessage()
        if (mensajeAbierto === false) {
            setMessage(textoMensaje);
            setMessageVisibility('');
            mensajeAbierto = true;
        } else {
            mensajeEnEspera = textoMensaje;
        }
    }

    function ocultarMessage() {
        mensajeAbierto = false;
        // Si hay un mensaje en espera, tras cerrar el mensaje actual se vuelve a
        // ejecutar la función mostrarMessage con el mensaje en espera y se
        // restablece su valor a '' para no entrar en bucle.
        if (mensajeEnEspera === '') {
            setMessageVisibility('hidden');
        } else {
            mostrarMessage(mensajeEnEspera);
            mensajeEnEspera = '';
        }

        if (juegoComenzado === false) {
            setManoVisibility(true);
            juegoComenzado = true;
        }
    }

    function mostrarOcultarResolverPanel() {
        setResolverPanelVisibility(!resolverPanelVisibility);
    }

    function mostrarOcultarAnimacion() {
        setAnimationVisibility(!animationVisibility);
    }

    function mostrarOcultarHome() {
        setHomeVisibility(!homeVisibility);
    }

    function mostrarOcultarInstrucciones() {
        setInstructionsVisibility(!instructionsVisibility);
        setHomeVisibility(false);
    }

    /* ------- FUNCIONES HANDLER PARA COMPONENTES HIJOS ------- */
    /* -------------------------------------------------------- */
    function buttonGirarClickHandler(fuerzaGiro) {
        girarRuleta(fuerzaGiro);
    }

    function inputLetterHandler(letra) {
        if (!letraYaMencionada(letra)) {
            ocultarInputLetter();
        }
    }

    function comprarVocalHandler() {
        setInputLetterType('vocal');
        setInputLetterVisibility('');
    }

    /* ------------- FUNCIONES PROPIAS DEL JUEGO -------------- */
    /* -------------------------------------------------------- */
    function girarRuleta(gradosGiro) {
        setButtonGirarState('disabled');
        const ruletaImg = document.getElementById('ruleta__img');
        const tiempoGiro = 6000;
        ruletaImg.style.transition = `all ${tiempoGiro}ms 
                                      cubic-bezier(.6,.20,.25,.99)`;
        grados += gradosGiro;
        console.log(`Girar hasta el grado: ${grados}`);
        ruletaImg.style.transform = `rotate(${grados}deg)`;

        // Al detenerse, reseteo los grados de la ruleta para que nunca pase 360
        setTimeout(() => {
            while (grados >= 360) { grados -= 360; }
            ruletaImg.style.transition = 'initial';
            ruletaImg.style.transform = `rotate(${grados}deg)`;
        }, tiempoGiro + 100);

        // Un poco después de detenerse, muestra al usuario el gajo en el que ha caído
        setTimeout(() => {
            const valorGajo = mapearGajos(grados);
            checkPierdeTurnoQuiebra(valorGajo);
            setButtonGirarState('');
        }, tiempoGiro + 800);
    }

    function checkPierdeTurnoQuiebra(valorGajo) {
        if (valorGajo === 'quiebra') {
            setTotalPoints(0);
            mostrarMessage('Has caído en quiebra, tu puntación ahora es 0');
        } else if (valorGajo === 'pierde turno') {
            mostrarMessage('Has caído en Pierde Turno, sigues tirando pero sumas 1 falta');
            setFaltas(faltas + 1);
        } else {
            setCurrentPoints(valorGajo);
            mostrarPanel();
            mostrarInputLetter();
        }
    }

    function letraYaMencionada(letra) {
        let letraMencionada = false;
        letrasMencionadas.forEach((item) => {
            if (item[1] === letra) {
                letraMencionada = true;
            }
        });
        if (letraMencionada) {
            setFaltas(faltas + 1);
            mostrarMessage(`Ops! La letra ${letra} ya está mencionada, sumas 1 falta`);
            return true;
        }
        if (letra === '' || letra === ' ') {
            mostrarMessage('Debes escribir una letra');
            return true;
        }
        revisarLetraEnPanel(letra);
        return false;
    }

    function revisarLetraEnPanel(letraIntroducida) {
        const letrasAcertadas = document.querySelectorAll(`.letra-${letraIntroducida}`);
        const vocales = 'AEIOU';
        let claseLetra = '';
        if (letrasAcertadas.length > 0) {
            claseLetra = 'letra-acertada';
            setTimeout(() => {
                // Las vocales no suman puntos
                if (vocales.includes(letraIntroducida)) {
                    sumarPuntos('vocal');
                } else {
                    sumarPuntos(letrasAcertadas.length);
                }
                let delay = 1000;
                letrasAcertadas.forEach((letra) => {
                    letra.classList.remove('letra-none');
                    letra.lastChild.classList.add('letra_back_ok');
                    letra.style.transitionDelay = `${delay}ms`;
                    letra.style.transform = 'rotateY(180deg)';
                    delay += 800;
                });
                 comprobarPanelCompletado(delay);
            }, 1000);
        } else {
            // Comprar vocal resta 50 puntos aunque no esté en el panel
            if (vocales.includes(letraIntroducida)) {
                setTotalPoints(totalPoints - 50);
            }
            claseLetra = 'letra-fallada';
            setFaltas(faltas + 1);
            setNumeroAciertos(0);
            setAnimationVisibility(true);
        }

        setLetrasMencionadas([...letrasMencionadas, [claseLetra, letraIntroducida]]);
    }

    function sumarPuntos(cantidadLetrasAcertadas) {
        if (cantidadLetrasAcertadas === 'vocal') {
            setTotalPoints(totalPoints - 50);
            setNumeroAciertos('vocal');
            setAnimationVisibility(true);
            return;
        }
        if (currentPoints === 'x2') {
            setTotalPoints(totalPoints * 2);
        } else if (currentPoints === '1/2') {
            setTotalPoints(totalPoints / 2);
        } else {
            setTotalPoints(totalPoints + (cantidadLetrasAcertadas * currentPoints));
        }
        setNumeroAciertos(cantidadLetrasAcertadas);
        setAnimationVisibility(true);
    }

    function resolverPanel(textarea) {
        // Normaliza las frases y quita los puntos, las comas y los espacios para hacer la comparación
        const frasePanelNormalizada = frasePanel[0].normalize('NFD').replace(/[\u0300-\u036f,. ]/g, '');
        const textAreaNormalizada = textarea.normalize('NFD').replace(/[\u0300-\u036f,. ]/g, '');
        if (frasePanelNormalizada === textAreaNormalizada.toUpperCase()) {
            const letras = document.querySelectorAll('.letra-none');
            // Espera 1500ms antes de marcar todas las letras para darle un poco de emoción
            setTimeout(() => {
                letras.forEach((letra) => {
                    letra.lastChild.classList.add('letra_back_ok');
                    letra.classList.remove('letra-none');
                    letra.style.transitionDelay = '1500ms';
                    letra.style.transform = 'rotateY(180deg)';
                });
            }, 1500);
            setTimeout(() => {
                comprobarPanelCompletado(0);
            }, 4200);
        } else {
            setFaltas(faltas + 1);
            mostrarMessage('Ups, parece que no acertaste el panel, sumas 1 falta');
            console.log(`Mensaje de panel: Mensaje en espera ${mensajeEnEspera}`);
        }
    }

    function comprobarPanelCompletado(delay) {
        console.log('Comprobando si el panel está completo');
        const letrasSinGirar = document.querySelectorAll('.letra-none').length;
        if (letrasSinGirar === 0) {
            setTimeout(() => {
                guardarPuntuacion();
            }, delay);
        }
    }

    function guardarPuntuacion() {
        juegoComenzado = 'end';
        // Desactivo los botones para que no se pueda seguir interactuando
        setButtonGirarState('disabled');
        setButtonResolverState('disabled');
        setButtonVocalState('disabled');
        setNextPanelVisibility(true);

        // Guarda en localStorage un array en Json con los paneles ya resueltos, incluyendo este
        localStorage.setItem('panelesResueltos', JSON.stringify(frasePanel[1]));
        console.log(`Paneles en localStorage al finalizar: ${frasePanel[1]}`);

        const mejorPuntuacionStorage = localStorage.getItem('mejorpuntuacion');
        const puntuacionTotal = totalPoints.toString();
        // Si ya se ha jugado antes comprueba si la nueva puntuación es menor o mayor a la anterior máxima
        if (mejorPuntuacionStorage !== null) {
            if (mejorPuntuacionStorage < totalPoints) {
                localStorage.setItem('mejorpuntuacion', puntuacionTotal);
                mostrarMessage(<div className="final-message">
                                <img className="copawin" src={`${process.env.PUBLIC_URL}/img/copawin.png`} alt="copa" />
                                <div>
                                    <b>¡ENHORABUENA!</b><br /><br /> Has completado el panel, ¡y además has
                                    superado tu mejor puntuación anterior de <b>{mejorPuntuacionStorage}!</b>
                                    <br />Tu nueva puntuación máxima es <b>{puntuacionTotal}</b>
                                </div>
                               </div>);
            } else {
                mostrarMessage(<div className="final-message">
                                <img className="copawin" src={`${process.env.PUBLIC_URL}/img/copawin.png`} alt="copa" />
                                <div>
                                    <b>¡ENHORABUENA!</b><br /><br />Has completado el panel, sin embargo,
                                    no has superado tu mejor puntuación de <b>{mejorPuntuacionStorage}</b>
                                </div>
                               </div>);
            }
        // Si no se ha jugado antes, guarda la puntuación directamente en el localStorage
        } else {
            localStorage.setItem('mejorpuntuacion', puntuacionTotal);
            mostrarMessage(<div className="final-message">
                            <img className="copawin" src={`${process.env.PUBLIC_URL}/img/copawin.png`} alt="copa" />
                            <div>
                                <b>¡ENHORABUENA!</b><br /><br /> Has completado el panel, tu
                                mejor puntuación ahora es de <b>{puntuacionTotal}</b>,
                                ¡juega otra vez e intenta superarte!
                            </div>
                           </div>);
        }
    }

    function siguientePanel() {
        window.location.reload();
    }

    return (
        <div id="game__container" className="game__container">
            <header className="game__header">
                <Cabecera currentPoints={currentPoints} totalPoints={totalPoints} faltas={faltas} homeClickHandler={mostrarOcultarHome} />
            </header>
            <main className="game__main">
                <Panel frasePanel={frasePanel[0]} panelSize={panelSize} onClickHandler={mostrarPanel} />
                <div className={`buttons-wrapper ${buttonsWrapperVisibility}`}>
                    <Button text="Comprar vocal" type="button-vocal" onClickHandler={comprarVocalHandler} state={buttonVocalState} />
                    <Button text="Resolver panel" type="button-resolve" onClickHandler={mostrarOcultarResolverPanel} state={buttonResolverState} />
                </div>
                {nextPanelVisibility
                    ? <Button text="JUGAR OTRO PANEL" type="button-next-panel" onClickHandler={siguientePanel} />
                    : null}
                {resolverPanelVisibility
                    ? <ResolverPanel onClickHandler={resolverPanel} onCloseHandler={mostrarOcultarResolverPanel} />
                    : null}
                {animationVisibility
                    ? <Animation numeroAciertos={numeroAciertos} cifraActual={currentPoints} closeAnimationHandler={mostrarOcultarAnimacion} />
                    : null}
                {homeVisibility
                    ? <Home instructionsClicKHandler={mostrarOcultarInstrucciones} continueClickHandler={mostrarOcultarHome} />
                    : null}
                {instructionsVisibility
                    ? <Messages text={Instrucciones} onClickHandler={mostrarOcultarInstrucciones} />
                    : null}
                <Ruleta ruletaSize={ruletaSize} onClickHandler={mostrarRuleta} />
                <InputLetter inputType={inputLetterType} inputHandler={inputLetterHandler} onCloseHandler={ocultarInputLetter} state={inputLetterVisibility} />
                <Messages text={message} state={messageVisibility} onClickHandler={ocultarMessage} />
                {manoVisibility
                  ? <img src={`${process.env.PUBLIC_URL}/img/mano.png`} alt="mano" className="mano__img" />
                  : null }
            </main>
            <footer className="game__footer">
                <InputRange buttonClickHandler={buttonGirarClickHandler} inputRangeVisibility={inputRangeVisibility} buttonGirarState={buttonGirarState} />
                <LetrasMencionadas letras={letrasMencionadas} letrasMencionadasVisibility={letrasMencionadasVisibility} />
            </footer>
        </div>
    );

};

export default Game;
